import { moveToFulfilled, moveToPending, moveToRejected } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type {
  BroadcastActivityDetailsLoadFulfilledAction,
  BroadcastActivityDetailsLoadPendingAction,
  BroadcastActivityDetailsLoadRejectedAction,
} from '../../domains/broadcastActivityDetails/actions.types';

import type { BroadcastActivityDetailsEntities } from './types';

export type BroadcastActivityDetailsLoadAction =
  | BroadcastActivityDetailsLoadPendingAction
  | BroadcastActivityDetailsLoadFulfilledAction
  | BroadcastActivityDetailsLoadRejectedAction;

const initialState: BroadcastActivityDetailsEntities = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<BroadcastActivityDetailsEntities, BroadcastActivityDetailsLoadAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'BROADCAST_ACTIVITY_DETAILS.LOAD_PENDING':
      return moveToPending(state, [action.payload.broadcastId]);
    case 'BROADCAST_ACTIVITY_DETAILS.LOAD_REJECTED':
      return moveToRejected(state, [action.payload.broadcastId], action.payload.error);
    case 'BROADCAST_ACTIVITY_DETAILS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.broadcastActivityDetails);
    default:
      return state;
  }
};

export default reducer;
